import { useState, useMemo, useCallback } from 'react';

export interface ConditionGroupFilters {
  search: string;
  status: string;
  order: string;
  page: number;
  limit: number;
}

export const useConditionGroupFilters = () => {
  const [filters, setFilters] = useState<ConditionGroupFilters>({
    search: '',
    status: 'all',
    order: 'all',
    page: 1,
    limit: 25,
  });

  const handleFilterChange = useCallback((key: keyof ConditionGroupFilters, value: string | number) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      // Reset page when filters change (except when changing page itself)
      ...(key !== 'page' && { page: 1 }),
    }));
  }, []);

  const queryParams = useMemo(() => {
    const params: Record<string, any> = {
      page: filters.page,
      limit: filters.limit,
    };
    if (filters.search) params.search = filters.search;
    if (filters.status !== 'all') params.status = filters.status;
    if (filters.order !== 'all') params.order = filters.order;
    return params;
  }, [filters]);

  // Memoize the returned object to prevent re-renders
  return useMemo(() => ({
    filters,
    queryParams,
    handleFilterChange,
    setFilters,
  }), [filters, queryParams, handleFilterChange]);
}; 